import type { PackagingPlanRow } from "./packaging-report-types.js";
import type { QuantityResult } from "./packaging-quantities.js";
import { displayPlanAllocations } from "./packaging-day-plan.js";
import { isPackagingWorkOrderPending } from "./packaging-work-order.js";

/** Consume each row's verified weekly production once, in plan-day order. */
export function dayPlanFulfillment(plan: PackagingPlanRow, date: string, weeklyActual: QuantityResult): QuantityResult {
  if (isPackagingWorkOrderPending(plan)) return { value: null, unit: null, reason: "İş emri bekleniyor" };
  const allocations = displayPlanAllocations(plan);
  if (allocations.some((item) => !Number.isFinite(item.quantity) || item.quantity < 0)) {
    return { value: null, unit: null, reason: "Excel plan miktarı geçersiz" };
  }
  const target = allocations.filter((item) => item.date === date).reduce((sum, item) => sum + item.quantity, 0);
  if (target === 0) return { value: 0, unit: "KOLİ", reason: null };
  if (weeklyActual.value === null) return weeklyActual;
  const preceding = allocations.filter((item) => item.date < date).reduce((sum, item) => sum + item.quantity, 0);
  return { value: Math.min(target, Math.max(0, weeklyActual.value - preceding)), unit: "KOLİ", reason: null };
}
